/**
 * O texto de uma notícia, pronto para `v-html`.
 *
 * Mora aqui, e não dentro do `Home.vue`, por um motivo prático: o jest deste
 * repositório não transforma `.vue` (ver `jest.config.js`, que só passa `.js`
 * por babel), então nada dentro de um SFC é testável direto. Uma correção de
 * segurança sem teste é exatamente o tipo de coisa que volta na próxima
 * refatoração de template.
 */

/**
 * Escapa o que vai virar HTML.
 *
 * O retorno de `formatDescription` vai para um `v-html`, que não filtra nada.
 * Sem escape, uma descrição com `<img src=x onerror=…>` executa no navegador de
 * todo jogador que abrir a Home. O texto vem do painel de admin, mas "só o admin
 * escreve" não é defesa — é a descrição de um XSS que precisa de uma conta
 * comprometida em vez de nenhuma.
 */
export function escapeHtml(texto) {
  return String(texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Quebras de linha viram `<br>`, e URLs viram links clicáveis.
 *
 * A ordem importa: cada palavra é escapada **antes** de virar HTML, e o `<a>` é
 * montado depois. Assim não há como fechar o atributo `href` de dentro do texto
 * — que é o que uma palavra como `http://x" onmouseover="alert(1)` faria na
 * versão anterior, onde a interpolação era crua.
 */
export function formatarDescricao(description) {
  if (!description) return '';

  return description
    .split('\n')
    .map((line) =>
      line
        .split(' ')
        .map((word) => {
          const seguro = escapeHtml(word);
          if (/^https?:\/\//i.test(word)) {
            return `<a href="${seguro}" target="_blank" rel="noopener noreferrer" class="inline-link">${seguro}</a>`;
          }
          return seguro;
        })
        .join(' '),
    )
    .join('<br>');
}
